import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  SadieSimulatorFitRequest,
  SadieSimulatorFitResponse,
} from "@/types";

export function useSimulateSadieFit() {
  return useMutation({
    mutationFn: async (request: SadieSimulatorFitRequest) => {
      const res = await guacHttpClient.post<
        SadieSimulatorFitResponse,
        HttpResponse<SadieSimulatorFitResponse>
      >("relationships/simulate/fit", request);
      return res.data;
    },
  });
}
